var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center items-center"},[_c('img',{staticClass:"max-w-full h-auto object-contain",attrs:{"src":_vm.gifSrc,"alt":"GIF","width":"400","height":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }